import { render } from "./Viewer.vue?vue&type=template&id=2fbc2c8a&scoped=true"
import script from "./Viewer.vue?vue&type=script&lang=js"
export * from "./Viewer.vue?vue&type=script&lang=js"

import "./Viewer.vue?vue&type=style&index=0&id=2fbc2c8a&scoped=true&lang=css"

import exportComponent from "/Users/jinming/Documents/jhapps/frontendadmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fbc2c8a"]])

export default __exports__